<template>
  <div class="animated fadeIn" id="list-decomptes">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-justify mr-2"></i>
          <strong>Gestion des canaux des dossiers</strong>
        </div>
        <b-card-body class="small-padding">
          <b-row class="">
            <b-col md="4">
              <SlickList  lockAxis="y" v-model="allCanals" class="list-group" :useDragHandle="true" @sort-end="">
                <item-list v-for="(canal, index) in allCanals" :index="index" :key="index" :item="canal" :selectedItemId="canalId">{{ canal.libelle }} <span class="smaller-2 ml-2">(groupe : {{ canal.groupe.toUpperCase() }})</span><i v-if="canManageCanal()" class="icon fa fa-trash float-right clickable ml-2 text-danger" @click="deleteCanal(canal.id)"></i><i v-if="canManageCanal()" class="icon fa fa-pencil float-right clickable" @click="edit(canal)"></i></item-list>
              </SlickList>
            </b-col>
            <b-col md="8">
              <b-card :header-bg-variant="action === 'create' ? 'primary' : 'warning' ">
                <template v-slot:header >
                   <i class="fa fa-justify mr-2"></i>
                  <strong>{{ libelleFormCardTitle }}</strong>
                </template>
                <!-- <div slot="header" :class="getHeaderClass()">
                  <i class="fa fa-justify mr-2"></i>
                  <strong>{{ libelleFormCardTitle }}</strong>
                </div> -->
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      label='Libellé'
                      label-for='libelle'
                    >
                      <b-form-input id='libelle' type='text' v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.libelle }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Libellé technique'
                      label-for='libelleTechnique'
                    >
                      <b-form-input id='libelleTechnique' type='text' v-model="libelleTechnique" :class="{hasError: errors.libelleTechnique !== ''}" :disabled="action !== 'create'"></b-form-input>
                      <span class='field-error'>{{ errors.libelleTechnique }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Groupe'
                      label-for='groupe'
                    >
                      <b-form-input id='groupe' type='text' v-model="groupe" :class="{hasError: errors.groupe !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.groupe }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Boite mail rattachée">
                      <b-form-radio v-model="selectedBal" name="bal" value="null">Aucune</b-form-radio>
                      <b-form-radio v-for="bal in allBals" :key="bal.id" v-model="selectedBal" name="bal" :value="bal.id" :disabled="isBalDisabled[bal.id]">{{ bal.nom }}</b-form-radio>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-button v-if="action === 'create'" size="md" variant="primary" @click="create()" class="mr-2 mt-1 pull-right"><i class="fa fa-save"></i> Créer</b-button>
                    <b-button v-if="action === 'modify'" size="md" variant="warning" @click="modify()" class="mr-2 mt-1 pull-right"><i class="fa fa-save"></i> Modifier</b-button>
                    <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-2 mt-1 pull-right">
                      <i class="fa fa-eraser"></i> Annuler
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </transition>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import { hasRule, espaceGestionRules as rules } from "@/utils/rulesHelper"
import { SlickList } from 'vue-slicksort'
import itemList from '@/components/SortListItem'
import {isEmpty} from "../../../utils/fileHelper";

export default {
  components: {
    SlickList,
    itemList
  },
  data() {
    return {
      canalId: 0,
      allCanals: [],
      allBals: [],
      balsUsed: [],
      selectedBal: null,
      libelle: '',
      libelleTechnique: '',
      groupe: '',
      action: 'create',
      libelleFormCardTitle: 'Création d\'un canal',
      errors: {
        libelle: '',
        libelleTechnique: '',
        groupe: '',
      }
    }
  },
  watch: {
    allCanals: function() {
      if (this.canManageCanal()) {
        this.sorted()
      }
    },
  },
  async mounted() {
    await this.getCanals();
    this.calculUsedBals();
    this.getBals();
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
  },
  computed: {
    isBalDisabled(bal) {
      let bals = [];
      for (let bal of this.allBals) {
        bals[bal.id] = false;
      }
      for (let canal of this.allCanals) {
        if (!isEmpty(canal.bal_id)) {
          bals[canal.bal_id] = true;
        }
      }
      return bals;
      console.log(bal.id,this.balsUsed.indexOf(bal.id))
      return this.balsUsed.indexOf(bal.id) > -1;
    },
  },
  methods: {
    getCanals() {
      return new Promise(resolve => {
        let self = this

        this.$store.commit("IS_LOADING", true)
        this.$axios
          .get("/espaceGestion/dossier/getAllCanal")
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.allCanals = response.data.data;
            // this.calculUsedBals();
            resolve();
          })
          .catch(function(error) {
            // console.log(error)
            self.$store.commit("IS_LOADING", false);
            resolve();
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            })
          })
      });
    },
    calculUsedBals() {
      for (let canal of this.allCanals) {
        if (!isEmpty(canal.bal_id)) {
          this.balsUsed.push(canal.bal_id);
        }
      }
    },
    getBals() {
      return new Promise(resolve => {
        let self = this
        let dataPost = {
          'provider': getProvider()
        }
        this.$store.commit("IS_LOADING", true)
        this.$axios
          .post("/espaceGestion/mail/getBals", dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false)
            // console.log(response)
            this.allBals = response.data.bals
            resolve();
          })
          .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            resolve();
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            })
          })
      });
    },
    sorted() {
      // console.log(this.allBaskets)
      let self = this;
      let dataPost = {
        'provider': getProvider(),
        'canals': this.allCanals
      }
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .post('/espaceGestion/parametrage/canal/sort', dataPost)
        .then(response => {
          this.$store.commit('IS_LOADING', false)
          // console.log(response)
          // this.groupBals = _.groupBy(response.data.bals,'entreprise')
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue lors du tri, si le problème persiste merci de faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    create() {
      if (this.validate()) {
        let self = this;
        let dataPost = {
          // 'provider': getProvider(),
          'libelle': this.libelle,
          'libelle_technique': this.libelleTechnique,
          'groupe': this.groupe,
          'bal_id': this.selectedBal,
          'ordre': 99,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/espaceGestion/parametrage/canal/add', dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            this.clearForm();
            this.clearError();
            this.manageChange();
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la création du canal, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    modify() {
      if (this.validate()) {
        let self = this;
        let dataPost = {
          // 'provider': getProvider(),
          'libelle': this.libelle,
          'libelle_technique': this.libelleTechnique,
          'bal_id': this.selectedBal,
          'groupe': this.groupe,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/espaceGestion/parametrage/canal/modify/'+this.canalId, dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            this.clearForm();
            this.clearError();
            this.manageChange();
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la modification du canal, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    deleteCanal(canalId) {
      let self = this;
      this.$swal
        .fire({
          title: "Êtes-vous sûr?",
          text: "Voulez-vous vraiment supprimer ce canal ?",
          type: "warning",
          reverseButtons: true,
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#ff1744",
          confirmButtonText: "Annuler",
          cancelButtonText: "Supprimer"
        })
        .then(result => {
          if (!result.value) {
            this.$store.commit("IS_LOADING", true)
            this.$axios
              .get("/espaceGestion/parametrage/canal/delete/"+canalId).then(response => {
                this.$store.commit("IS_LOADING", false);
                //this.manageChange();
              })
              .catch(function(error) {
                  self.$store.commit("IS_LOADING", false);
                  let errorText = "Une erreur est survenue, lors de la suppression du canal. Si le problème persiste, merci de faire un ticket au support DOSI."
                  if (error.response.status === 403) { errorText = "Vous n'êtes pas autorisé à effectuer cette action" }
                  if (error.response.status === 406) { errorText =  error.response.data.message}
                  self.$swal({
                  position: "top",
                  type:"error",
                  title:"Attention !!",
                  text:errorText,
                  showConfirmButton: false,
                  timer: 5000
                })
              })
          }
        })
    },
    canManageCanal() {
      return hasRule(rules.CAN_CONFIGURE_DOSSIER)
    },
    async manageChange() {
      await this.getCanals();
      this.calculUsedBals();
      // Forcing refresh bal list render
      let allBals = this.allBals;
      this.allBals = [];
      this.allBals = allBals;
    },
    edit(canal) {
      this.selectedBal = canal.bal_id
      this.libelle = canal.libelle
      this.libelleTechnique = canal.libelle_technique
      this.groupe = canal.groupe
      this.canalId = canal.id
      this.action = 'modify'
      this.libelleFormCardTitle = 'Modification du canal : ' + canal.libelle
    },
    validate() {
      let valid = true

      if (this.libelle === '') {
        this.errors.libelle = 'Le libelle est obligatoire'
        valid = false;
      }

      if (this.libelleTechnique === '') {
        this.errors.libelleTechnique = 'Le libelle technique est obligatoire'
        valid = false;
      }

      if (this.groupe === '') {
        this.errors.groupe = 'Le groupe est obligatoire'
        valid = false;
      }

      return valid
    },
    // isBalDisabled(bal) {
    //   console.log(bal.id,this.balsUsed.indexOf(bal.id))
    //   return this.balsUsed.indexOf(bal.id) > -1;
    // },
    clearForm() {
      this.clearError()
      this.selectedBal = null
      this.libelle = ''
      this.libelleTechnique = ''
      this.groupe = ''
      this.canalId = 0
      this.action = 'create'
      this.libelleFormCardTitle = 'Création d\'un canal'
    },
    clearError() {
      this.errors.libelle = ''
      this.errors.libelleTechnique = ''
      this.errors.groupe = ''
    },
  }
}
</script>
